import React from 'react';

export default function LongTextIcon() {
  return (
    <svg width="256px" height="256px" viewBox="0 0 256 256" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>Long Text</title>
      <desc>Created with Sketch.</desc>
      <g id="Long-Text" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-2" transform="translate(6.000000, 33.000000)">
          <path
            d="M1,-2.84217094e-14 L244,-2.87547763e-14 C244.552285,-2.88562294e-14 245,0.44771525 245,1 L245,164.676689 C245,165.228974 244.552285,165.676689 244,165.676689 L119.531616,165.676689 L78.0307668,207.894011 C77.6435988,208.287863 77.010457,208.293282 76.616605,207.906114 C76.4253549,207.718109 76.3176346,207.461165 76.3176346,207.192981 L76.3176346,165.676689 L1,165.676689 C0.44771525,165.676689 9.91459674e-14,165.228974 9.85878046e-14,164.676689 L8.52651283e-14,1 C8.51974929e-14,0.44771525 0.44771525,-2.83202564e-14 1,-2.84217094e-14 Z"
            id="Path-2"
            stroke="currentColor"
            strokeWidth="14"
          ></path>
          <g id="Group" transform="translate(46.000000, 43.000000)" fill="currentColor">
            <rect id="Rectangle" x="1" y="0" width="109" height="14" rx="7"></rect>
            <rect id="Rectangle-Copy" x="0" y="33" width="150" height="14" rx="7"></rect>
            <rect id="Rectangle-Copy-2" x="1" y="66" width="150" height="14" rx="7"></rect>
          </g>
        </g>
      </g>
    </svg>
  );
}
